import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { StoreUser, User } from '../models/user.model';

const initialStateUserProfile: User = {
  email: '',
  name: '',
  lastName: '',
  phone: '',
  role: null,
  address: [],
  genre: null,
  status: null,
  _id: '',
  dni: '',
  birthDate: '',
  favorites: [],
};

const initialState: StoreUser = {
  isFetching: false,
  userProfile: initialStateUserProfile,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    refreshUserStore: (state, action: PayloadAction<User>) => {
      state = { ...state, ...action.payload };
      return state;
    },
    refreshUserFavorites: (state, action: PayloadAction<string[]>) => {
      state.userProfile.favorites = action.payload;
      return state;
    },
    refreshUserJwtData: (state, action: PayloadAction<Pick<User, 'name' | 'lastName' | 'email'>>) => {
      state.userProfile.name = action.payload.name;
      state.userProfile.lastName = action.payload.lastName;
      state.userProfile.email = action.payload.email;
      return state;
    },
    refreshUserProfile: (state, action: PayloadAction<User>) => {
      state.userProfile = action.payload;
      return state;
    },
    fetchingRefresh: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
      return state;
    },
    resetUserStore: () => initialState,
  },
});

export const UserSlice = userSlice.actions;
export default userSlice.reducer;
